var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1000008517(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 35,
    viewBox: "0 0 61 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.6165,
    cy: 9.82155,
    r: 7.4114,
    fill: "#F7B53C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3867 33.1154V24.6455C17.3867 20.5525 20.7048 17.2344 24.7979 17.2344H36.444C40.5371 17.2344 43.8551 20.5525 43.8551 24.6455V33.1154",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 33.1108V29.9346C1.5 25.8415 4.81809 22.5234 8.91116 22.5234H9.44052",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7315 33.1108V29.9346C59.7315 25.8415 56.4135 22.5234 52.3204 22.5234H51.791",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43821 22.5288C12.3618 22.5288 14.7319 20.1587 14.7319 17.2351C14.7319 14.3115 12.3618 11.9414 9.43821 11.9414C6.5146 11.9414 4.14453 14.3115 4.14453 17.2351C4.14453 20.1587 6.5146 22.5288 9.43821 22.5288Z",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7976 22.5288C54.7212 22.5288 57.0913 20.1587 57.0913 17.2351C57.0913 14.3115 54.7212 11.9414 51.7976 11.9414C48.874 11.9414 46.5039 14.3115 46.5039 17.2351C46.5039 20.1587 48.874 22.5288 51.7976 22.5288Z",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6202 17.2326C35.0056 17.2326 38.5607 13.6775 38.5607 9.29209C38.5607 4.90669 35.0056 1.35156 30.6202 1.35156C26.2348 1.35156 22.6797 4.90669 22.6797 9.29209C22.6797 13.6775 26.2348 17.2326 30.6202 17.2326Z",
    stroke: "white",
    strokeWidth: 2.11754,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000008517);
export default __webpack_public_path__ + "static/media/Group 1000008517.337645dbb917dcc74164b827abfcb18e.svg";
export { ForwardRef as ReactComponent };